import '../admin/bootbox';
import '../admin/select2';
import '../admin/bootstrap-select';
import '../admin/datepicker';
import '../admin/moment';
import '../admin/payment';
import '../admin/datatable';
// import '../admin/ionicons';
import '../admin/functions';

(function(i,s,o,g,r,a,m){i['TDConversionObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script', 'https://svht.tradedoubler.com/tr_sdk.js?org=2290630&prog=318979&dr=true&rand=' + Math.random(), 'tdconv');


$(document).ready(function() {

    $('.select-ajax').select2({
        "theme": "bootstrap",
        ajax: {
            url: function (params) {
                return $(this).data('url')+'/'+params.term ;
            },
            delay: 500,
            type: 'GET',
            dataType: 'json',
            processResults: function (data) {
                $(data.element).attr('data-custom-attribute', 'test');
                console.log(data);
                return {
                    results: data
                };
            }
        },
        templateResult: function (data) {
            return data.text;
        },
        templateSelection : function(data){

            order.address_data = data.item;
            $(data.element).attr('data-custom-attribute', JSON.stringify(data));
            return data.text;
        },
        minimumInputLength : 4,
    });

    $('.select-ajax').on('select2:select', function (e) {
        var value = $(this).val();
        var parts = value.split('__');
        $('input[name=post_code]').val(parts[1]);
    });

    $('#contact-us-form').submit(function(e){
        e.preventDefault();
    });

    $('#contact-us-form .send').click(function(){
        $('#contact-us-form').submit();
    });
});



// WEBPACK FOOTER //
// ./resources/js/app/index.js